import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "e-badge e-badge-success e-badge-pill" }
const _hoisted_2 = { class: "e-badge e-badge-danger e-badge-pill" }
const _hoisted_3 = { class: "e-badge e-badge-success e-badge-pill" }
const _hoisted_4 = { class: "e-badge e-badge-danger e-badge-pill" }

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import GdvAccess from "@/shared/model/GdvAccess";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";

interface Props {
  data?:GdvAccess
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'GdvAccessListItemComponent',
  props: {
    data: { default: undefined }
  },
  setup(__props: any) {


const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        SubTitle: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.data.description), 1)
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.data.id) + " ", 1)
        ]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("td", null, "Benutzername", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.userName
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[1] || (_cache[1] = _createElementVNode("td", null, "Addresse", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.address
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("td", null, "Modus", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.mode
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[3] || (_cache[3] = _createElementVNode("td", null, "Kommunikationpartner Id", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.communicationPartnerIdentifer
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[4] || (_cache[4] = _createElementVNode("td", null, "Logintoken", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.loginToken
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("td", null, "Logintoken gültig bis", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.logingTokenValidityDate,
                  "value-type": _unref(SogDataLabelValueType).DateTime
                }, null, 8, ["value", "value-type"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[6] || (_cache[6] = _createElementVNode("td", null, "Letzes Loginversuch", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.lastLoginDate,
                  "value-type": _unref(SogDataLabelValueType).DateTime
                }, null, 8, ["value", "value-type"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[7] || (_cache[7] = _createElementVNode("td", null, "Pin Fehlversuche", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.pinError
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("td", null, "PIN erlaubte Fehlversuche", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.pinErrorAllowed
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[9] || (_cache[9] = _createElementVNode("td", null, "Gesperrt", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.accountBlockedText
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[10] || (_cache[10] = _createElementVNode("td", null, "Aktiv", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("span", _hoisted_1, "ja", 512), [
                  [_vShow, __props.data?.active]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_2, "nein", 512), [
                  [_vShow, !__props.data?.active]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[11] || (_cache[11] = _createElementVNode("td", null, "Pin-Gültigkeit", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.pinValidity
                }, null, 8, ["value"]),
                _createVNode(SogDataLabel, { value: "Tag(e)" })
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[12] || (_cache[12] = _createElementVNode("td", null, "Status", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.statusText
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[13] || (_cache[13] = _createElementVNode("td", null, "Briefkasten", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("span", _hoisted_3, "ja", 512), [
                  [_vShow, __props.data?.briefkasten]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_4, "nein", 512), [
                  [_vShow, !__props.data?.briefkasten]
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[14] || (_cache[14] = _createElementVNode("td", null, "Transferbriefkasten Ids", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, {
                  value: __props.data?.transferBriefkastenIds
                }, null, 8, ["value"])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})